import router from 'router';

export default {
    getStaffTeam(staffid) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                `/rest/staffs/${staffid}/team`,
                {},
                resolve,
                reject,
            );
        }).then((response) => {
            if (response.error) {
                throw response;
            }
            return response;
        });
    },
    getBusinessActivities() {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                router.resolve({ name: 'legacy.onboarding.systemfields.activities' }).href,
                {},
                resolve,
                reject,
            );
        });
    },
    getBusinessEmployees() {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.get(
                router.resolve({ name: 'legacy.onboarding.systemfields.employees' }).href,
                {},
                resolve,
                reject,
            );
        });
    },
    updateSystemfields(staffid, data) {
        return new Promise((resolve, reject) => {
            window.SellsyJS.WebServiceCaller.put(
                router.resolve({
                    name: 'legacy.onboarding.systemfields.update',
                    params: { staffid: staffid },
                }).href,
                {},
                data,
                (response) => resolve(response),
                (error) => reject(error.response.data.error.message),
            );
        });
    },
    getStaff(staffid) {
        return new Promise((resolve, reject) => {
            ApiClient.get(`/settings/staffs/${staffid}`, {
                embed: ['licenses'],
            })
                .then((response) => {
                    resolve({ staff: response });
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    createStaff(staff) {
        return new Promise((resolve, reject) => {
            ApiClient.post(router.resolve({ name: 'api.staff.create' }).href, {}, staff)
                .then((response) => {
                    resolve({ staff: response });
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    getStaffs() {
        return new Promise((resolve, reject) => {
            ApiClient.get(router.resolve({ name: 'api.staff.create' }).href)
                .then((response) => {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    updateStaff(staff) {
        return new Promise((resolve, reject) => {
            ApiClient.put(
                router.resolve({ name: 'api.staff.update', params: { staffid: staff.id } }).href,
                {},
                staff,
            )
                .then((response) => {
                    resolve({ staff: response });
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    getTeamsList() {
        return new Promise((resolve, reject) => {
            ApiClient.get(router.resolve({ name: 'api.teams' }).href, {})
                .then((response) => {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    getProfilesList(order = '') {
        const params = { limit: 100 };
        if (order !== '') {
            params['order'] = order;
        }

        return new Promise((resolve, reject) => {
            ApiClient.get(router.resolve({ name: 'api.profiles' }).href, params)
                .then((response) => {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    },
    getStaffPermission(staffId) {
        return ApiClient.get(`staffs/${staffId}`, { embed: ['acl'] });
    },
    async getAllActiveStaff() {
        let data = [];
        let pagination = { offset: '', total: 0 };
        const filters = {
            status: ['ok'],
        };
        do {
            const response = (
                await ApiClient.post(
                    '/staffs/search',
                    { offset: pagination.offset },
                    {
                        filters,
                    },
                )
            ).data;
            pagination = response?.pagination ?? pagination;
            data = data.concat(response?.data ?? []);
        } while (data.length < pagination.total);
        return data;
    },
};
